<template>
  <el-main class="userwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/shop' }">店铺信息</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}店铺信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">店铺信息</div>

        <el-form-item label="门店：" prop="name">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.name" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="排序值：" prop="sort">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.sort" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="门店编号：" prop="store_code">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.store_code" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="门店验证码：" prop="verify_code">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.verify_code" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="地区：" prop="quyu">
          <el-col :span="12">
            <el-cascader style="width: 100%;" :options="options" v-model="form.quyu" @change="handleChange">
            </el-cascader>
          </el-col>
        </el-form-item>

        <el-form-item label="地址：" prop="address">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.address" clearable />
          </el-col>
        </el-form-item>

        <!-- <el-form-item label="上传图片：" prop="img_name">
          <el-upload action="#" list-type="picture-card" :file-list="fileList" :auto-upload="false" :before-upload="beforeUpload" :on-change="imgchange">
            <i slot="default" class="el-icon-picture-outline dimg">
              <p>点击上传图</p>
            </i>
            <div slot="file" slot-scope="{ file }" class="img-file">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!imgDisabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item> -->

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>


<script>
import * as api from '@/api'
import _ from 'lodash'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'UserDetail',
  data() {
    return {
      options: regionData,
      form: {
        quyu: ['', '', ''],
      },
      shopList: [],
      perPage: 30,
      p: 1,
      total: 30,
      rules: {
        id: [
          {
            required: true,
            message: '请选择名店',
            trigger: 'change',
          },
        ],
      },
      imgDisabled: false,
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
    }
  },
  mounted() {

  },
  created() {
    this.$route.query.id && this.getShopDetail(this.query.id)
    this.getShopList()
  },
  methods: {
    async getShopDetail(id) {
      api.getShopDetail({
        shop_id: id,
      })
        .then((res) => {
          let {
            id,
            name,
            sort,
            store_code,
            verify_code,
            province,
            city,
            area,
            address,
          } = res.resData
          if (city == '北京市' || city == '上海市' || city == '天津市' || city == '重庆市') { //两种不同差价需要处理
            city = '市辖区'
          }
          this.form = {
            id,
            name,
            sort,
            store_code,
            verify_code,
            province,
            city,
            area,
            address,
            quyu: [
              TextToCode?.[province]?.code,
              TextToCode?.[province]?.[city]?.code,
              TextToCode?.[province]?.[city]?.[area]?.code,
            ],
          }
          this.fileList.push({
            url: res.httpImg
          })
          this.$forceUpdate()
          return res
        })
    },
    async getShopList() {
      const postData = {}
      api.getShopList(postData)
        .then((res) => {
          this.shopList = res.resData.itemList
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateShop()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateShop() {
      this.form.shop_id = this.form.id
      this.form.option = this.form.id ? '2' : '1'
      this.form.province = CodeToText[this.form.quyu[0]]
      this.form.city = CodeToText[this.form.quyu[1]]
      this.form.area = CodeToText[this.form.quyu[2]]
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.id
      delete tempForm.quyu
      api.updateShopInfo(tempForm).then((res) => {
        if (res.status == 200) {
          this.$message.success(res)
          this.$router.go(-1)
        }
      })
    },
    handleChange(value) {
      console.log(CodeToText, value)
    },
    beforeUpload(file) {
      this.fileList = []
      console.log(file)
      return true
    },
    imgchange(file, filelist) {
      this.fileList = []
      console.log(file, filelist)
      this.fileList = [file]
      this.checkImg(file.url)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.form.img_name = ''
      this.fileList = _.without(fileList, file)
    },
    checkImg(url) {
      const img = new Image()
      img.src = url
      if (img.complete) {
        console.log(
          'from:complete  :width:' + img.width + ',height:' + img.height
        )
      } else {
        img.onload = function () {
          let dataURL = ''
          let canvas = document.createElement('canvas')
          let width = img.width // 确保canvas的尺寸和图片一样
          let height = img.height
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(img, 0, 0, width, height)
          dataURL = canvas.toDataURL('image/png')
          this.uploadImage(dataURL)
        }.bind(this)
      }
    },
    uploadImage(img) {
      api.uploadImage({
        file_arr: img,
        type: 4,
      })
      .then((res) => {
        this.form.img_name = res.img_name
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.userwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}

.img-file {
  @extend %center;
  height: 100%;
  .el-upload-list__item-thumbnail {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
    object-fit: contain;
  }
}
</style>